
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/epm",
      function () {
        return require("private-next-pages/pam/epm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/epm"])
      });
    }
  